import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
const colors = {
    rainbow: [
        'border-t-gray-50',
        'animate-[loader-spin-color_1s_linear_infinite]',
        'before:animate-[loader-spin-color_1s_linear_infinite]',
    ],
    white: [
        'border-t-gray-50',
        'animate-[loader-spin_1s_linear_infinite]',
        'before:animate-[loader-spin_1s_linear_infinite]',
    ],
};
const sizes = {
    md: 'h-[64px] w-[64px] border-[6px]',
    sm: 'h-[32px] w-[32px] border-4',
    xs: 'h-[20px] w-[20px] border-2',
};
export const Spinner = (props) => {
    const { className = '', color = 'white', size = 'md' } = props;
    return (_jsx("div", { className: clsx('inline-block', 'relative', 'rounded-full', 'border-solid border-transparent', colors[color], sizes[size], className) }));
};
